import { FilterValues } from "interfaces/filter/filter";
import { filterUtils } from "utils/business/filterUtils";

export const initSavedTopBottomFilter = (savedFilters?: FilterValues): FilterValues => {

    if (!savedFilters) {
        return null;
    }
    const startDate = savedFilters?.operationDate?.startDate
    const endDate = savedFilters?.operationDate?.endDate
    return {
        ...filterUtils.initSavedPerimeterFilters(savedFilters),
        operationDate: {
            ...savedFilters?.operationDate,
            key: "selection",
            startDate: startDate ? new Date(startDate) : new Date(),
            endDate: endDate ? new Date(endDate) : new Date(),
        }
    }
}
export const initSavedTrendsFilter = (savedFilters?: FilterValues): FilterValues => {

    if (!savedFilters) {
        return null;
    }

    return {
        ...filterUtils.initSavedPerimeterFilters(savedFilters)
    }
}
